import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from "class-validator";
import { LeadRankConfig } from "../lead-rank-config";
import { HomeValueSource } from "./customer-lead.schema";

export class LeadRankScore {
  @Expose()
  @IsString()
  @IsNotEmpty()
  id: string;

  @Expose()
  @IsNumber()
  leadRankScore: number;

  @Expose()
  @IsNumber()
  leadRank: number;

  @Expose()
  @IsEnum(HomeValueSource)
  homeValueSource: HomeValueSource;

  @Expose()
  @ValidateNested()
  @Type(() => LeadRankConfig)
  leadRankConfig: LeadRankConfig;

  @Expose()
  @IsDate()
  createdTs: Date;

  @Expose()
  @IsDate()
  updatedTs: Date;
}

export class CustomerLead {
  public static from(customerLead: CustomerLead) {
    return plainToInstance(CustomerLead, customerLead, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  id: string;

  @Expose()
  @IsString()
  @IsOptional()
  email?: string;

  @Expose()
  @IsString()
  @IsOptional()
  firstName?: string;

  @Expose()
  @IsString()
  @IsOptional()
  lastName?: string;

  @Expose()
  @IsString()
  @IsOptional()
  leadSource?: string;

  /** Self-reported attribution ("How did you hear about Yardzen?"). */
  @Expose()
  @IsString()
  @IsOptional()
  heardAboutUs?: string;

  @Expose()
  @IsString()
  @IsOptional()
  yzAnonymousId?: string;

  @Expose()
  @IsString()
  @IsOptional()
  zipcode?: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  score?: number;

  @Expose()
  @IsNumber()
  @IsOptional()
  leadScoreVersion?: number;

  @Expose()
  @ValidateNested()
  @Type(() => LeadRankScore)
  @IsOptional()
  leadRankScore?: LeadRankScore;

  @Expose()
  @IsString()
  @IsOptional()
  leadRankScoreId?: string;

  @Expose()
  @IsString()
  @IsOptional()
  phone?: string;

  @Expose()
  @IsString()
  @IsOptional()
  addressLine1?: string;

  @Expose()
  @IsString()
  @IsOptional()
  addressLine2?: string;

  @Expose()
  @IsString()
  @IsOptional()
  city?: string;

  @Expose()
  @IsString()
  @IsOptional()
  state?: string;

  @Expose()
  @IsNumber()
  @IsOptional()
  homeEstimateValue?: number;

  @Expose()
  @IsDate()
  createdTs: Date;

  @Expose()
  @IsDate()
  @IsOptional()
  updatedTs?: Date;
}
